import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BubbleMenu } from '@tiptap/react';
import { LinkFormattingMenu } from '../../components/LinkBubbleMenu';
import { useComposer } from '../../hooks/useComposer';
export const LinkFormattingBubbleMenu = ({ editor }) => {
    const { state } = useComposer();
    return (_jsx(_Fragment, { children: _jsx(BubbleMenu, { pluginKey: "link-bubble-menu", shouldShow: ({ editor, from, to }) => {
                return Math.abs(to - from) > 0 && editor.isActive('custom-link');
            }, editor: editor, tippyOptions: {
                arrow: true,
                placement: 'bottom-start',
            }, children: !state.textFormatMenu && _jsx(LinkFormattingMenu, { editor: editor }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=link.js.map